(function (){
    'use strict';

    angular
        .module('services')
        .service('ExpoService', ExpoService);

    ExpoService.$inject = ['$http', 'API_BASE'];

    function ExpoService ($http, API_BASE) {
        var service = this;
        service.getExpos                    = getExpos;
        service.getExposAudience            = getExposAudience;
        service.getSeminars                 = getSeminars;
        service.getExposVirtualFair         = getExposVirtualFair;
        service.getExpoVirtualBySemester    = getExpoVirtualBySemester;
        service.getExposForSelect           = getExposForSelect;
        service.getExposByExpositors        = getExposByExpositors;
        service.getDateOfExpo               = getDateOfExpo;
        service.getExpoBySemester           = getExpoBySemester;
        service.getSemester                 = getSemester;
        service.getNewExpos                 = getNewExpos;
        service.getSemesters                = getSemesters;
        service.getExposHuddle              = getExposHuddle;
        service.getExposCities              = getExposCities;
        service.getBoothTypesForSelect      = getBoothTypesForSelect;
        service.getByTotalStudents          = getByTotalStudents;
        service.getExposBySettings          = getExposBySettings;
        service.getExpoTypes                = getExpoTypes;
        service.getAliases                  = getAliases;
        service.getEventGroups              = getEventGroups;
        service.getProfileTypes             = getProfileTypes;
        service.getServiceRegions           = getServiceRegions;
        service.getExpoAddresses            = getExpoAddresses;
        service.getAllExpoCities            = getAllExpoCities;
        service.getPhysicalFairBySettings   = getPhysicalFairBySettings;
        service.savePhysicalFairSettings    = savePhysicalFairSettings;
        service.eventContacts               = eventContacts;
        service.eventContactsCsv            = eventContactsCsv;
        service.getEventVenues              = getEventVenues;
        service.saveEventVenue              = saveEventVenue;
        service.getByFilterApproved         = getByFilterApproved;
        service.getByFilterApprovedCSV      = getByFilterApprovedCSV;
        service.getAlbums                   = getAlbums;
        service.getVideos                   = getVideos;
        service.getBrochures                = getBrochures;
        service.getNationalities            = getNationalities;
        service.getRepresentatives          = getRepresentatives;
        service.getPhotos                   = getPhotos;
        service.getBooths                   = getBooths;
        service.getHubLoginUrl              = getHubLoginUrl;
        service.getGeneralInformation       = getGeneralInformation;
        service.postEvents                  = postEvents;
        service.getSeminarById              = getSeminarById;
        service.storeSeminar                = storeSeminar;
        service.getByFilterSeminars         = getByFilterSeminars;
        service.deleteSeminar               = deleteSeminar;
        service.updateSeminar               = updateSeminar;
        service.sendEmailTest               = sendEmailTest;
        service.physicalFairSettingsStatus  = physicalFairSettingsStatus;

        function getExpos (query) {
            return $http.get(API_BASE + '/expos/list', {params : query});
        }

        function getExposAudience(query) {
            return $http.get(API_BASE + '/email/audience/expos', {params: query});
        }

        function getSeminars () {
            return $http.get(API_BASE + '/expos/seminars/list');
        }

        function getExposVirtualFair(data) {
            return $http.get(API_BASE + '/expos/virtualfair/list',{params:data});
        }

        function getExpoVirtualBySemester(data) {
            return $http.get(API_BASE + '/expos/virtualfair/bysemester',{params:data});
        }

        function getExposForSelect(filters) {
            return $http.get(API_BASE + '/expos/list_select',{params:filters});
        }

        function getDateOfExpo (data) {
            return $http.get(API_BASE + '/expos/date/',{params:data});
        }

        function getExposByExpositors () {
            return $http.get(API_BASE + '/expositors/expos/list');
        }

        function getExpoBySemester (data) {
            return $http.get(API_BASE + '/expos/bysemester',{params:data});
        }

        function getSemester () {
            return $http.get(API_BASE + '/expos/semester/list');
        }

        function getNewExpos () {
            return $http.get(API_BASE + '/expos/news');
        }

        function getSemesters () {
            return $http.get(API_BASE + '/expos/semesters/list');
        }

        function getExposHuddle(query) {
            return $http.get(API_BASE + '/expos/huddle/list', {params: query});
        }

        function getExposCities(data) {
            return $http.get(API_BASE + '/expos/cities', {params : data});
        }

        function getBoothTypesForSelect(query) {
            return $http.get(API_BASE + '/expos/boothtypes', {params: query});
        }

        function getByTotalStudents(query, platformRental = false) {
          return $http.get(API_BASE + "/physicalfairs/platform-rental/getStudentsTotal" + (platformRental ? '?platform-rental=1' : ''), {
            params: query,
          });
        }

        function getExposBySettings(query) {
            return $http.get(API_BASE + '/physicalfairs/settings/list', {params: query});
        }

        function getPhysicalFairBySettings(id) {
            return $http.get(API_BASE + "/physicalfairs/settings/" + id + "/edit");
        }

        function getExpoTypes(query) {
            return $http.get(API_BASE + '/physicalfairs/expo-types/list', {params: query});
        }
        
        function getAliases(query) {
            return $http.get(API_BASE + '/physicalfairs/aliases/list', {params: query});
        }

        function getEventGroups(query) {
            return $http.get(API_BASE + '/physicalfairs/event-groups/list', {params: query});
        } 

        function getProfileTypes(query) {
            return $http.get(API_BASE + '/physicalfairs/profile-types/list', {params: query});
        }

        function getServiceRegions(query) {
            return $http.get(API_BASE + '/physicalfairs/service-regions/list', {params: query});
        }

        function getExpoAddresses(query) {
            return $http.get(API_BASE + '/physicalfairs/addresses/list', {params: query});
        }

        function getEventVenues(query) {
            return $http.get(API_BASE + '/physicalfairs/event-venues/list', {params: query});
        }

        function saveEventVenue(query) {
            return $http.post(API_BASE + '/physicalfairs/event-venue', query);
        }

        function getAllExpoCities(query) {
            return $http.get(API_BASE + '/physicalfairs/cities/list', {params: query});
        }

        function savePhysicalFairSettings(query) {
            let formData = new FormData();
            Object.keys(query).forEach(key => formData.append(key, query[key]));
            return $http.post(API_BASE + "/physicalfairs/settings", formData, {
              transformRequest: angular.identity,
              headers: {'Content-Type': undefined}
            });
        }

        function eventContacts(data) {
            return $http.get(API_BASE + "/physicalfairs/event-contacts", {params: data});
        }
      
        function eventContactsCsv(data) {
            return $http.get(API_BASE + "/physicalfairs/event-contacts/csv", {params: data});
        }

        /* APPROVED */
        function getByFilterApproved(query) {
            return $http.get(API_BASE + "/physicalfairs/approved", { params: query });
        }
    
        function getByFilterApprovedCSV(query) {
            return $http.get(API_BASE + "/physicalfairs/approved/csv", { params: query });
        }
    
        function getAlbums(query) {
            return $http.get(API_BASE + "/physicalfairs/approved/albums", {
            params: query,
            });
        }
    
        function getVideos(query) {
            return $http.get(API_BASE + "/physicalfairs/approved/videos", {
            params: query,
            });
        }
    
        function getBrochures(query) {
            return $http.get(API_BASE + "/physicalfairs/approved/brochures", {
            params: query,
            });
        }
    
        function getNationalities(query) {
            return $http.get(API_BASE + "/physicalfairs/approved/nationalities", {
            params: query,
            });
        }
    
        function getRepresentatives(query) {
            return $http.get(API_BASE + "/physicalfairs/approved/representatives", {
            params: query,
            });
        }
    
        function getPhotos(query) {
            return $http.get(API_BASE + "/physicalfairs/approved/photos", {
            params: query,
            });
        }
    
        function getBooths(query) {
            return $http.get(API_BASE + "/physicalfairs/approved/booths", {
            params: query,
            });
        }

        function getHubLoginUrl(email, token, expo_id) {
            let query = {};
            query['email'] = email;
            query['token'] = token;
            query['expo_id'] = expo_id;
            return $http.get(API_BASE + "/physicalfairs/get-hub-login-url", {
              params: query,
            });
        }

        function getGeneralInformation(query) {
            return $http.get(API_BASE + "/physicalfairs/general-information", {
                params: query,
              });
        }
        
        function postEvents() {
            let query = {};
            return $http.get(API_BASE + "/physicalfairs/post-events", {
                params: query,
            });
        }

        function getSeminarById(id) {
            return $http.get(API_BASE + "/physicalfairs/seminar/" + id);
        }

        function getByFilterSeminars(id) {
            return $http.get(API_BASE + "/physicalfairs/seminars");
        } 

        function storeSeminar(data) {
            return $http
              .post(API_BASE + "/physicalfairs/seminar/store", data)
              .then(function (response) {
                return response.data;
              });
        }

        function deleteSeminar(id) {
            return $http.delete(API_BASE + "/physicalfairs/seminar/" + id);
        }

        function updateSeminar(data, id) {
        return $http
          .put(API_BASE + "/physicalfairs/seminar/", data)
          .then(function (response) {
            return response.data;
          });
        }

        function sendEmailTest(data) {
            return $http.post(API_BASE + "/physicalfairs/settings/email-test", data);
        }

        function physicalFairSettingsStatus(id) {
            return $http.post(API_BASE + "/physicalfairs/settings/" + id + '/status');
        }
    }
})();